export const safeParseInt = (input: string | null | undefined) => {
  if (!input) {
    return undefined
  }
  const int = Number.parseInt(input)
  if (!Number.isSafeInteger(int)) {
    return undefined
  }
  return int
}
